import React from 'react';
import PropTypes from 'prop-types';
import { UniversalLink } from '@plone/volto/components';
import { ICONS } from '../Cards/icons';

const ARROW = (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

const ButtonView = ({ data }) => {
  const legacyHref = Array.isArray(data.href)
    ? data.href[0]?.['@id'] || ''
    : data.href;
  const label = data.label || data.title || 'Botão';
  const variant = data.variant || 'primary';
  const size = data.size || 'md';
  const align = data.align || data.inneralign || 'left';
  const iconPosition = data.iconPosition || 'none';
  const iconKey = data.icon;
  const openInNewTab = data.openInNewTab ?? data.openLinkInNewTab;

  const iconSvg = iconKey ? ICONS[iconKey] : iconPosition !== 'none' ? ARROW : null;

  const classes = [
    'ag-btn',
    `ag-btn--${variant}`,
    `ag-btn--${size}`,
  ].join(' ');

  const inner = (
    <>
      {iconSvg && iconPosition === 'left' && (
        <span className="ag-btn__icon">{iconSvg}</span>
      )}
      <span className="ag-btn__label">{label}</span>
      {iconSvg && iconPosition === 'right' && (
        <span className="ag-btn__icon">{iconSvg}</span>
      )}
    </>
  );

  return (
    <div className={`ag-btn-wrap ag-btn-wrap--${align}`}>
      {legacyHref ? (
        <UniversalLink
          href={legacyHref}
          className={classes}
          openLinkInNewTab={openInNewTab}
        >
          {inner}
          {/* aviso só para o leitor de tela: na tela o botão não muda */}
          {openInNewTab && (
            <span className="ag-btn__so-leitor"> (abre em nova aba)</span>
          )}
        </UniversalLink>
      ) : (
        <button type="button" className={classes} disabled>
          {inner}
        </button>
      )}
    </div>
  );
};

ButtonView.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string,
    href: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    title: PropTypes.string,
    inneralign: PropTypes.string,
    openLinkInNewTab: PropTypes.bool,
    variant: PropTypes.string,
    size: PropTypes.string,
    align: PropTypes.string,
    iconPosition: PropTypes.string,
    icon: PropTypes.string,
    openInNewTab: PropTypes.bool,
  }).isRequired,
};

export default ButtonView;
